import React from 'react';
import {useUser} from "./Components/UserProvider";

import AppLogo from './assets/images/logo.png';
import { NavLink } from 'react-router-dom';

import European from './assets/images/european.svg';
import { FormattedMessage } from 'react-intl';

export function Menu({ title, href, icon }) {
    return <NavLink activeClassName="active" to={href}>{icon && <i className={"me-2 fas fa-" + icon} />}{title}</NavLink>
}

export default function Sidebar({ children }) {
    const user = useUser();

    return <div className="bar">
        <img className="logo" src={AppLogo} />
        <div className="custom-menu">
            { children }
        </div>
        <div className="text-center">
            <p><b>SPINENT 2.0</b></p>
            <p>&copy; <FormattedMessage id="COPYRIGHT" />.</p>
            <img src={European} alt="" />
        </div>
    </div>;
}
